import { useState } from "react";
import useAppState from "../../context/AppContext";
import { upsaleStudies } from '../../services/CustomerApiService';
import MessageModal from "../../modals/common/MessageModal";
import { AxiosError } from "axios";
import { IApiErrors } from "../../context/model";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import { formatDateFR, handleKeyDown } from "../../utils/utils";

export default function EndBloc() {

    const {
        state: { jwtToken, proposition }
      } = useAppState();
    
    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowTextInfo, setIsShowTextInfo] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string | null>();

    const onConfirmAction = async () => {
        setIsShowModal(false);
        setIsShowTextInfo(false);
        try {
            const token = jwtToken!.accessToken;
            await upsaleStudies(token, proposition!.propositionId);
      
          } catch (error) {
            const err = error as AxiosError;
            console.log(err);
            if(err.response && err.response.status === 400) {
              const errorData = err.response?.data as IApiErrors;
              setErrorMsg("Erreur: " + errorData.message);
            } else {
              setErrorMsg("Une erreur technique est survenue ");
            }
          }
    };

    return (

        <div className="">
            <div className="ta-center">
                <p className="fw-bold fz-lg">Merci.</p>
                <p className="fw-bold fz-lg">Votre affiliation santé est maintenant finalisée.</p>
                <p className="m-y-md fz-lg">Vos prochaines étapes :</p>
                <div className="grid-flex">
                    <div className="box">
                        <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto-mail-1.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
                        <p className="fw-medium text">Je reçois ma confirmation d'affiliation par mail.</p>
                    </div>
                    <div className="box">
                        <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto-mail-2.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
                        <p className="fw-medium text">Je crée mon espace adhérent.</p>
                    </div>
                    <div className="box">
                        <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto-carte-3.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
                        <p className="fw-medium text">Je reçois ma carte tiers payant.</p>
                    </div>
                </div>
                <p className="fushia fz-lg fw-bold m-y-sm">Le {formatDateFR(proposition!.effectiveDate)}, votre mutuelle santé MGP sera active.</p>
                {isShowTextInfo && 
                  <div className="bg-menthe p-xs blanc m-y-md ta-center">
                    <p className="text">La MGP vous propose également des offres de prévoyance adaptées à votre métier (maintien de salaire, décès).</p>
                    <p className="text">Pour être contacté par un conseiller MGP <span className="link" onClick={() => setIsShowModal(true)} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>cliquez ici</span></p>
                  </div>
                }
                <a className="cta-bleu cta-small m-y-md" href={process.env.REACT_APP_CMS_BASE_URL}>Retourner à accueil </a>
            </div>
            
            {isShowModal && <MessageModal type="general" message="Votre demande a été prise en compte. Un conseiller MGP vous contactera prochainement." closeAction={onConfirmAction}></MessageModal>}
            <div>
                {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
            </div>
        </div>
  )
}